import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Radio from 'components/newComponents/RadioButton';
import Api from '../api';

const InsuranceOptionsForm = ({ jobId, next, refetchContract, setPending }) => {
  const handleSubmit = async (values) => {
    setPending(true);

    try {
      await Api.insurance(values.job_id, values.insurance_option);
      await refetchContract();
      next();
    } catch (e) {}

    setPending(false);
  };

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={Yup.object().shape({
        job_id: Yup.string(),
        insurance_option: Yup.number().required('Required').min(1, 'Required'),
      })}
      initialValues={{ job_id: jobId, insurance_option: 0 }}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, handleSubmit, errors }) => {
        return (
          <form id="ld-contract-invoice-modal" onSubmit={handleSubmit}>
            <div className="ld-contract-invoice-modal-body">
              <Radio
                value={1}
                title="Option 1 - Standard Valuation Coverage: PLEASE READ CAREFULLY - by choosing this Option you are waiving certain valuable coverage which protects your possessions above the minimum amounts by law."
                name="insurance_option"
                current={values.insurance_option}
                radioStyles={{ marginRight: 20, marginLeft: 0 }}
                titleStyles={{ fontWeight: 500, color: values.insurance_option === 1 ? 'black' : '#b1c3cc' }}
                onChange={() => setFieldValue('insurance_option', 1)}
              />
              <Radio
                value={2}
                title="Option 2 - Additional Valuation Coverage:Additional coverage is available to compensate you for goods lost or damaged at an amount closer to the declared or replacement value."
                name="insurance_option"
                current={values.insurance_option}
                radioStyles={{ marginRight: 20, marginLeft: 0 }}
                titleStyles={{ fontWeight: 500, color: values.insurance_option === 2 ? 'black' : '#b1c3cc' }}
                onChange={() => setFieldValue('insurance_option', 2)}
              />
              {errors.insurance_option && <span className="error">{errors.insurance_option}</span>}
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default InsuranceOptionsForm;
